import React from "react";
import { ABOUT_DATA } from "data";
import ReactHtmlParser from "react-html-parser";

const About = () => {
  window.scrollTo(0, 0);

  return (
    <div className="w-full bg-white py-16 px-4" id="about">
      <div className="max-w-[1240px] mx-auto flex justify-center">
        {/* <img className="w-[300px] mx-auto my-4" src={Laptop} alt="/" /> */}
        <div className="flex flex-col justify-center lg:w-6/12 xl:w-6/12">
          <p className="text-[#00df9a] font-bold ">ABOUT US</p>
          <h1 className="md:text-4xl sm:text-3xl text-2xl font-bold py-10">
            {ABOUT_DATA.header}
          </h1>
          <div>{ReactHtmlParser(ABOUT_DATA.detailedDescription)}</div>
        </div>
      </div>
    </div>
  );
};

export default About;
